module.exports = __webpack_public_path__ + "img/gridicons_stats-down.522f7840.svg";